import { useEffect } from "react";
import { Link } from "react-router-dom";
import PageShell from "@/components/site/PageShell";
import SEO from "@/components/site/SEO";

export default function NotFound() {
  // Evita que Google indexe esta página de error
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    meta.id = "robots-noindex-404";
    document.getElementById("robots-noindex-404")?.remove();
    document.head.appendChild(meta);
    return () => {
      document.getElementById("robots-noindex-404")?.remove();
    };
  }, []);

  return (
    <PageShell testid="page-404">
      <SEO
        title="Página no encontrada · Líneas Doradas S.A.S."
        description="La página que buscas no existe o fue movida. Vuelve al inicio o solicita tu cotización de transporte turístico."
      />
      <section className="relative pt-24 md:pt-32 pb-24 md:pb-32">
        <div className="orb-gold w-[460px] h-[460px] right-[-120px] top-[60px] opacity-50" />
        <div className="max-w-3xl mx-auto px-5 md:px-8 relative text-center">
          <div className="text-[#E8C87A] text-xs uppercase tracking-[0.35em] mb-4">Error 404</div>
          <h1 className="font-display text-4xl md:text-6xl leading-[1.05] text-[#F5EFE0]">
            <span className="italic text-gold-grad">Página no encontrada</span>
          </h1>
          <p className="text-[#F5EFE0]/70 mt-5 text-base md:text-lg leading-relaxed max-w-xl mx-auto">
            La dirección que buscas no existe o fue movida. Puedes volver al inicio o pedir tu cotización.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/" data-testid="404-home-btn" className="btn-gold px-8 py-3.5 rounded-full text-[15px]">Ir al inicio</Link>
            <Link to="/cotizar" data-testid="404-quote-btn" className="btn-ghost-gold px-8 py-3.5 rounded-full text-[15px]">Solicitar cotización</Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
